import { useActivityRequestsData } from "./hooks";
import { RequestList } from "../../../shared";
import { ActivityListItem } from "./ActivityListItem";
import { useCallback } from "react";
import { tsr } from "~/utils/client";
import { useToast } from "~/components/ui/toast";
import { captureException } from "@sentry/react";
import { useBulkSelectingState } from "@ses-mams/react-utils";

type OperationalListProps = {
  unitId?: string;
};

export const ActivityList = ({ unitId }: OperationalListProps) => {
  const queryClient = tsr.useQueryClient();

  const { mutateAsync, isPending: isClosing } =
    tsr.activities.closeMany.useMutation();

  const { addToast } = useToast();

  const { isBulkSelecting, setIsBulkSelecting, onSelect, selectedIds } =
    useBulkSelectingState();

  const handleCloseActivities = useCallback(async () => {
    try {
      await mutateAsync({
        body: {
          activityIds: [...selectedIds],
        },
      });

      await queryClient.invalidateQueries({
        queryKey: ["activity-requests", "list"],
      });

      setIsBulkSelecting(false);
    } catch (error) {
      captureException(error);

      addToast({
        tone: "critical",
        title: "Sorry, something went wrong",
        message: "Please try again",
      });
    }
  }, [selectedIds]);

  return (
    <RequestList
      unitId={unitId}
      dataHook={useActivityRequestsData}
      ListItemComponent={ActivityListItem}
      onConfirm={handleCloseActivities}
      isClosing={isClosing}
      isBulkSelecting={isBulkSelecting}
      setIsBulkSelecting={setIsBulkSelecting}
      selectedIds={selectedIds}
      onBulkSelect={onSelect}
      bulkCloseRoles={["ActivityCoordinator", "Administrator"]}
    />
  );
};
